import type { HttpClient } from '#src/fetching/http/http_client.ts';
import type {
  CreateGroupRequest,
  CreateGroupResponse,
  GetGroupForParticipantRequest,
  GetGroupForParticipantResponse,
  GetGroupRequest,
  GetGroupResponse,
  RecordMatchViewRequest,
  RecordMatchViewResponse,
} from '@packages/contracts/group';
import {
  CreateGroupResponseSchema,
  GetGroupForParticipantResponseSchema,
  GetGroupResponseSchema,
  RecordMatchViewResponseSchema,
} from '@packages/contracts/group';

export interface GroupClient {
  createGroup: (request: CreateGroupRequest) => Promise<CreateGroupResponse>;
  getGroup: (request: GetGroupRequest) => Promise<GetGroupResponse>;
  getGroupForParticipant: (
    request: GetGroupForParticipantRequest,
  ) => Promise<GetGroupForParticipantResponse>;
  recordMatchView: (request: RecordMatchViewRequest) => Promise<RecordMatchViewResponse>;
}

export function createGroupClient(http: HttpClient): GroupClient {
  return {
    async createGroup(request) {
      const response = await http.post('/group', request);
      return CreateGroupResponseSchema.parse(response);
    },
    async getGroup({ groupId }) {
      const response = await http.get(`/group/${encodeURIComponent(groupId)}`);
      return GetGroupResponseSchema.parse(response);
    },
    async getGroupForParticipant({ groupId, participantId }) {
      const response = await http.get(
        `/group/${encodeURIComponent(groupId)}/participant/${encodeURIComponent(participantId)}`,
      );
      return GetGroupForParticipantResponseSchema.parse(response);
    },
    async recordMatchView(request) {
      const response = await http.post('/group/recordmatchview', request);
      return RecordMatchViewResponseSchema.parse(response);
    },
  };
}
